import type { GA4AnalyticsEvent } from '@/domain/shared/types'
import { useCallback } from 'react'

export function useAnalytics() {
  function sendEvent<T = GA4AnalyticsEvent>(event: T) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(event)
  }

  return {
    sendEvent: useCallback(sendEvent, []),
  }
}
